module.exports = {"130608100":"清苑镇","130608101":"冉庄镇","130608102":"阳城镇","130608103":"魏村镇","130608104":"温仁镇","130608105":"张登镇","130608106":"大庄镇","130608107":"臧村镇","130608108":"望亭镇","130608109":"东闾镇","130608200":"白团乡","130608201":"北店乡","130608202":"石桥乡","130608203":"李庄乡","130608204":"北王力乡","130608206":"何桥乡","130608207":"孙村乡","130608208":"阎庄乡","130608400":"河北清苑经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130608.json
// module id = 242
// module chunks = 0